module.exports = __webpack_public_path__ + "img/hardware6.89322dd0.png";